var paragraph_default = {
  "fontElementMap": "NOD2i",
  "elementSpacing": "eBpBo",
  "text": "yU1AD eBpBo",
  "child": "yakoZ"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
